import React, { memo, useRef } from "react";
import * as S from "../../styles";

const ImageType = ({ url, setShowImage }) => {
  const imgElement = useRef(null);
  const height = imgElement?.current?.naturalHeight;
  const width = imgElement?.current?.naturalWidth;

  return (
    <>
      {url ? (
        <div onClick={setShowImage}>
          <S.Figure height={height} width={width}>
            <S.Image src={url} ref={imgElement} height={height} width={width} />
          </S.Figure>
        </div>
      ) : (
        <S.MessageLoading />
      )}
    </>
  );
};

export default memo(ImageType);
